import React from 'react';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Item,
  Divider,
  Button,
  Grid,
  Accordion
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import {FormattedMessage, injectIntl} from 'react-intl';

import EXISTComponent from './EXISTComponent';
import PartnersComponent from './PartnersComponent';
import RecordingStudiosComponent from './RecordingStudiosComponent';
import { PRIMARY_COLOR } from '../constants';
import { Link } from 'react-router-dom';



const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
        <Container text style={{padding: '5em 0em'}}>
            <Header
                as='h1'
                inverted
                style={{
                fontSize: mobile ? '2em' : '4em',
                fontWeight: 'normal',
                marginBottom: 0,
                }}
            >
                <FormattedMessage id="audory.responsiveContainer.body.faq.long"/>
            </Header>
            <Header
                as='h2'
                inverted
                style={{
                fontSize: mobile ? '1.5em' : '1.7em',
                fontWeight: 'normal',
                }}
            >
            </Header>
        
        </Container>
        
    </Segment>
)

class FAQPage extends React.Component {

    state = { activeIndex: null, activeHeadIndex: null }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  handleHeadClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeHeadIndex } = this.state
    const newIndex = activeHeadIndex === index ? -1 : index

    this.setState({ activeHeadIndex: newIndex, activeIndex: null })
  }

  render() {
    const { activeIndex, activeHeadIndex } = this.state
    console.log()

    return (
        <DivWrapper>
            <PageHeader />
            <Segment style={{ padding: '4em 0em', margin: 0 }}>
                <Container text>

                    {
                        true || this.props.intl.messages['audory.lang'] === 'de' ? (

                            <Accordion fluid styled>
                                <Accordion.Title
                                active={activeHeadIndex === 0}
                                index={0}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Allgemein
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 0}>
                                    <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Was ist ein interaktives Hörbuch?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                        Bei einem interaktiven Hörbuch hast du die Möglichkeit, den Verlauf der Geschichte zu beeinflussen. Das Hörbuch läuft nicht von Anfang bis Ende einfach durch, sondern dir wird an mehreren Stellen eine Frage angezeigt und verschiedene Antwortmöglichkeiten. Aus diesen kannst du dann wählen, welchen Weg die Geschichte nun einschlagen soll.
                                        </p>
                                        <p>
                                        Wenn du an einem Ende angekommen bist, kannst du die Geschichte jederzeit von vorne hören und nach Belieben andere Wege wählen.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Benötige ich die App, um Hörbücher hören zu können?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Ja. Diese ist jedoch kostenlos. In der App gibt es kostenfreie sowie kostenpflichtige Hörbücher. Probiere gern erst einmal die kostenfreien aus, um zu schauen, ob dich die Interaktivität genau so wie uns mitreißt.

                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Kann ich offline hören?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Selbstverständlich. Sobald du dein gewünschtes Hörbuch in deine Bibliothek heruntergeladen hast, kannst du es jederzeit an jedem Ort anhören. Ohne jegliche Internetverbindung.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 3}
                                        index={3}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Gibt es ein Abo?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 3}>
                                        <p>
                                        Nein. Hast du Lust ein interaktives Hörbuch zu hören? Dann kauf dir eins. Hast du mal zwei Monate keine Lust darauf? Auch okay. Du bist an kein Abonnement gebunden und kannst jederzeit entscheiden, wieviel Geld du wofür ausgibst.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 1}
                                index={1}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Kaufprozess
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 1}>
                                <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Wie kann ich ein interaktives Hörbuch kaufen?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                            Interaktive Hörbücher kannst du in unserer App nur mit Hörtalern kaufen. Das ist unsere eigene InApp-Währung, die du über zwei Wege erwerben kannst.
                                        </p>
                                        <p>
                                            Auf der einen Seite findest du direkt in unserer App im Shop unter "Hörtaler" verschiedene Angebote, die du direkt per InApp-Kauf erwerben kannst.
                                        </p>
                                        <p>
                                            Auf der anderen Seite kannst du auf unserer Website unter <Link to="/gutschein" style={{color: PRIMARY_COLOR}}>Gutscheine</Link> aus verschiedenen Angeboten wählen und die Gutscheincodes anschließend in der App im Shop unter "Hörtaler" einlösen.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Welche Zahlungsmöglichkeiten habe ich bei audory?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Zahlst du direkt über In-App Käufe in der App kümmern sich Google (Android) und Apple (iOS) um die Abwicklung mit deiner hinterlegten Zahlungsmethode.
                                        </p>
                                        <p>
                                        Kaufst du über unsere Website ( <Link to="/gutschein" style={{color: PRIMARY_COLOR}}>https://audory.io/gutschein</Link> ), dann läuft die Zahlung über PayPal.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Gibt es kostenlose Hörbücher?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Ja. Wir bieten in der App kostenpflichtige und kostenlose Hörbücher an. Da unser Editor von jedem genutzt werden kann, der Interesse hat ein interaktives Hörbuch zu erstellen, gibt es viele Autoren, die sich einfach mal ausprobieren oder euch etwas Gutes tun wollen und ihre Geschichten kostenlos zur Verfügung stellen.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 2}
                                index={2}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Persönliche Daten
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 2}>
                                <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Sammelt ihr Daten über mich?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                        Das ist deine Entscheidung! Wir zwingen dich nicht dazu, uns Daten über dich zu geben. Entscheidest du dich jedoch dafür, erhältst du von uns individuelle Hörbuch-Empfehlungen. Du entscheidest zu jedem Zeitpunkt selbst, ob du individuelle Empfehlungen von uns haben möchtest oder nicht.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Welche Daten sammelt ihr?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Wenn du zustimmst, dass du individuelle Empfehlungen erhalten möchtest, speichern wir deine getroffenen Entscheidungen ab. Wir nutzen weder deinen Standort, noch deine Kamera oder dein Mikrofon.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Wie verarbeitet ihr meine Daten?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Unser Algorithmus berechnet auf Grundlage deiner Entscheidungen, welche neuen interaktiven Hörbücher dir gefallen könnten und filtert diese für dich heraus. Dabei schaut sich keine natürliche Person, sondern ausschließlich unser Programm deine Entscheidungen an. Um den Algorithmus zu verbessern, hat unser Entwicklerteam die Möglichkeit, diese Daten einzusehen. Hierbei werden deine Daten unter Berücksichtigung des geltenden Datenschutzrechtes und unserer Sicherheitsstandards verarbeitet.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 3}
                                        index={3}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Was nutzen mir individuelle Empfehlungen?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 3}>
                                        <p>
                                        Ein Teil der audory-Dienste ist die persönliche Empfehlung interaktiver Hörbücher. Du bekommst auf dich zugeschnittene Hörbücher vorgeschlagen, die dir mit hoher Wahrscheinlichkeit gefallen werden. Damit wollen wir Fehlkäufe vermeiden, weil sie langfristig niemandem nutzen. Deine Daten werden ausschließlich für dich verwendet und niemals an Dritte verkauft oder für Werbung genutzt. Du behältst zu jedem Zeitpunkt die Kontrolle.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 3}
                                index={3}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Besonderes
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 3}>
                                <Accordion fluid styled>
                                    {
                                        /*
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                            <Icon name='dropdown' />
                                            Wofür gibt es in einigen Geschichten ein Inventar und was ist das überhaupt?
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === 0}>
                                            <p>
                                            Das ist deine Entscheidung! Wir zwingen dich nicht dazu, uns Daten über dich zu geben. Entscheidest du dich jedoch dafür, erhältst du von uns individuelle Hörbuch-Empfehlungen. Du entscheidest zu jedem Zeitpunkt selbst, ob du individuelle Empfehlungen von uns haben möchtest oder nicht.
                                            </p>
                                        </Accordion.Content>
                                        */
                                    }
                                        

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Wie muss ich eure Altersempfehlung verstehen?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Interaktive Hörbücher zählen wie Hörbücher und Bücher zu Medien, die keiner Altersfreigabe unterliegen, wie man es von Filmen (FSK) oder Videospielen (USK) kennt. Trotzdem möchten wir mit gutem Beispiel vorangehen und kennzeichnen alle interaktiven Hörbücher auf audory mit einer Altersempfehlung, an der sich Eltern und Kinder orientieren können.
                                        </p>
                                        <p>
                                        Unsere Altersempfehlung bedeutet, dass wir die Inhalte dieser Geschichte für das angegebene Alter für geeignet halten. Auch jüngere Kinder dürfen diese Geschichten hören.
                                        </p>
                                        <p>
                                        Kinder sind so unterschiedlich, dass eine Altersfreigabe und auch eine -Empfehlung niemals für jedes Kind perfekt passen kann. Auf welchen Kriterien unsere Altersempfehlungen basieren, haben wir deshalb genau aufgeschlüsselt:
                                        </p>
                                        <p><u>Empfohlen ab 0 Jahren:</u> Für alle Altersklassen geeignet.</p>
                                        <p><u>Empfohlen ab 6 Jahren:</u> Das Hörbuch enthält größere Spannungsbögen und eine leichte Dramatik darf vorhanden sein. Auch fiktionale (nicht bösartige) Inhalte können vorkommen. Das Hörbuch endet in jedem Fall positiv oder zumindest harmonisch. Nur leichte Formen von Gewalt (wie z.B. schubsen) dürfen vorhanden sein.</p>
                                        <p><u>Empfohlen ab 9 Jahren:</u> Das Hörbuch enthält unter Umständen ironische Inhalte, stärkere Beleidigungen/Schimpfworte und/oder endet nicht zwingend positiv/harmonisch. Auch Kämpfe (ohne explizite Beschreibungen) gegen negativ konnotierte Figuren können vorkommen sowie bösartige fiktionale Inhalte (Drachen, Hexen, Geister, Vampire, Werwölfe, …). Gesellschaftliche Themen (z.B. Mobbing, Umweltschutz, Klimawandel) können kindgerecht behandelt werden.</p>
                                        <p><u>Empfohlen ab 12 Jahren:</u> Gesellschaftliche Themen, wie z.B. Rassismus, Mobbing, Sprache, Sexualität, künstliche Intelligenz, Klimawandel, Umweltschutz, Drogen etc. werden seriös behandelt. Große Spannungsbögen und verängstigende Handlungen können vorhanden sein. Positiv konnotierte Figuren könnten sterben, das Hörbuch endet aber trotzdem positiv.</p>
                                        <p><u>Empfohlen ab 14 Jahren:</u> Erschreckende Handlungen können vorkommen. Gewalt ist vordergründiger und stärker. Ermordungen an positiv konnotierten Figuren könnten vorhanden sein, jedoch ohne (Teil-)Schuld des “Hörers”. Sexuelle Inhalte werden nicht ausführlich beschrieben, können aber vorkommen.</p>
                                        <p><u>Empfohlen ab 16 Jahren:</u> Extreme Gewalt/Verletzung/Ermordung kann vorkommen. Situationen und Beschreibungen könnten ekelerregend sein oder emotional stark aufwühlen. Angstzustände, geistige Verwirrung oder die (Teil-)Schuld an der Tötung positiv konnotierter Figuren könnten vorhanden sein. Sexuelle Inhalte werden detaillierter beschrieben.</p>
                                        <p><u>Empfohlen ab 18 Jahren:</u> Sehr verstörende, brutale oder stark ekelerregende Handlungen/Beschreibungen können vorkommen. Sexuelle Inhalte werden ausführlich mit allen Details beschrieben.</p>
                                        </Accordion.Content>

                                    </Accordion>
                                </Accordion.Content>

                            </Accordion>

                        ) : (

                            <Accordion fluid styled>
                                <Accordion.Title
                                active={activeHeadIndex === 0}
                                index={0}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                General
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 0}>
                                    <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        What is an interactive audio book?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                        With an interactive audiobook, you have the opportunity to affect the course of the story. The audiobook does not simply run through from beginning to end, but you are shown a question at several points and various possible answers. You can then choose from these which path the story should take.
                                        </p>
                                        <p>
                                        When you reach an end, you can always listen to the story again from the beginning and choose other paths at will.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Do I need the app to listen to audiobooks?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Yes, but this is free of charge. There are both free and paid audiobooks in the app. Feel free to try the free ones first to see if you like the interactivity as much as we do.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Can I listen offline?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Of course. Once you've downloaded your desired audiobook to your library, you can listen to it anytime, anywhere. Without any internet connection.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 3}
                                        index={3}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Is there a subscription?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 3}>
                                        <p>
                                        No. Do you want to listen to an interactive audio book? Buy one. Don't feel like it for two months? That's okay, too. You are not bound to a subscription and can decide at any time how much money you spend on what.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 1}
                                index={1}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Purchasing process
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 1}>
                                <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        How can I buy an interactive audiobook?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                        Depending on whether you use the app from the Apple Appstore or the Google Playstore, there are one or two options for you.
                                        </p>
                                        <p>
                                        As an iOS user, you purchase a coupon for an interactive audiobook through our website, which you can then use on <a style={{color: PRIMARY_COLOR}} target='_blank' href='https://gutschein.audory.io/'>https://gutschein.audory.io/</a> and download your audiobook.
                                        </p>
                                        <p>
                                        As an Android user, you can go the same way as iOS users or buy your audiobook directly in the app without using a coupon first. When you buy through the app, a portion goes to Google as a commission.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        What payment options do I have at audory?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        If you pay directly via in-app purchases in the Android app, Google takes care of the processing with your stored payment method.
                                        </p>
                                        <p>
                                        If you buy through our website ( <a style={{color: PRIMARY_COLOR}} target='_blank' href='https://audory.io/gutschein'>https://audory.io/gutschein</a> ), then the payment goes through PayPal.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Are there any free audiobooks?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Yes. We offer paid and free audiobooks in the app. Since our editor can be used by anyone who is interested in creating an interactive audiobook, there are many authors who just want to give it a try or do something good for you and provide their stories for free.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 2}
                                index={2}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Personal data
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 2}>
                                <Accordion fluid styled>
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        Are you collecting data about me?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 0}>
                                        <p>
                                        This is your decision! We do not force you to give us data about yourself. However, if you decide to do so, you will receive individual audio book recommendations from us. You decide at any time whether you want to receive individual recommendations from us or not.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        What data are you collecting?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        If you agree to receive customized recommendations, we store the choices you make. We do not use your location, camera or microphone.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 2}
                                        index={2}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        How do you process my data?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2}>
                                        <p>
                                        Based on your decisions, our algorithm calculates which new interactive audiobooks you might like and filters them out for you. No natural person, but only our program looks at your decisions. In order to improve the algorithm, our development team has the possibility to view this data. Your data is processed in accordance with the applicable data protection laws and our security standards.
                                        </p>
                                        </Accordion.Content>

                                        <Accordion.Title
                                        active={activeIndex === 3}
                                        index={3}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        What use are individual recommendations to me?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 3}>
                                        <p>
                                        Part of audory's services is the personal recommendation of interactive audiobooks. You will receive audio books customized for you that you will most probably like. In this way, we want to avoid bad purchases, because they benefit no one in the long run. Your data will only be used for you and will never be sold to third parties or used for advertising. You remain in control at all times.
                                        </p>
                                        </Accordion.Content>
                                    </Accordion>
                                </Accordion.Content>

                                <Accordion.Title
                                active={activeHeadIndex === 3}
                                index={3}
                                onClick={this.handleHeadClick}
                                >
                                <Icon name='dropdown' />
                                Special
                                </Accordion.Title>
                                <Accordion.Content active={activeHeadIndex === 3}>
                                <Accordion fluid styled>
                                    {
                                        /*
                                        <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={this.handleClick}
                                        >
                                            <Icon name='dropdown' />
                                            Wofür gibt es in einigen Geschichten ein Inventar und was ist das überhaupt?
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === 0}>
                                            <p>
                                            Das ist deine Entscheidung! Wir zwingen dich nicht dazu, uns Daten über dich zu geben. Entscheidest du dich jedoch dafür, erhältst du von uns individuelle Hörbuch-Empfehlungen. Du entscheidest zu jedem Zeitpunkt selbst, ob du individuelle Empfehlungen von uns haben möchtest oder nicht.
                                            </p>
                                        </Accordion.Content>
                                        */
                                    }
                                        

                                        <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={this.handleClick}
                                        >
                                        <Icon name='dropdown' />
                                        How should I understand your age recommendation?
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>
                                        <p>
                                        Like audiobooks and books, interactive audiobooks are media that are not subject to any age rating, as is the case with movies (FSK) or video games (USK). Nevertheless, we want to set a good example and mark all interactive audiobooks on audory with an age recommendation that parents and children can use as a guide.
                                        </p>
                                        <p>
                                        Our age recommendation means that we consider the content of this story suitable for the age indicated. Younger children may also listen to these stories.
                                        </p>
                                        <p>
                                        Children are so different that an age rating and also an age recommendation can never fit perfectly for every child. We have therefore broken down the criteria on which our age recommendations are based:
                                        </p>
                                        <p><u>Recommended from age 0:</u> Suitable for all age groups.</p>
                                        <p><u>Recommended from age 6:</u> The stories may contain suspense and some drama. A positive or at least harmonious ending is present.</p>
                                        <p><u>Recommended from age 9:</u> Fictional content (dragons, witches, ghosts, vampires, werewolves, ...) may be present.</p>
                                        <p><u>Recommended from age 12:</u> Serious examination of social issues, such as racism, language, artificial intelligence, climate change, environmental protection and drugs.</p>
                                        <p><u>Recommended from age 14:</u> Some form of violence is present. This includes, for example, being held against one's will, beating, but also psychological violence (frightening or similar).</p>
                                        <p><u>Recommended from age 16:</u> Willful injury/murder with blood or sexual acts present.</p>
                                        <p><u>Recommended from age 18:</u> Contents such as sexual acts, injuries, violence, ... are explicitly described.</p>
                                        </Accordion.Content>

                                    </Accordion>
                                </Accordion.Content>

                            </Accordion>

                        )
                    }

                    
                </Container>
            </Segment>
        </DivWrapper>
    );
  }
}


export default injectIntl(FAQPage);


// WEBPACK FOOTER //
// ./src/components/FAQPage.js